export enum UserMetadataKey {
  ACTIVE_ORGANIZATION = 'active_org',
  LANGUAGE = 'language',
  INITIAL_LOGIN_TYPE = 'initial_login_type',
  IS_TOUR_COMPLETE = 'is_tour_complete',
}
